import { useTranslation } from 'react-i18next'
import type { ValidationFinding } from '@/services/api/schemas'
import { FindingRow } from './FindingRow'

export interface DialogValidationFindingsProps {
  findings?: ValidationFinding[] | null
}

/**
 * Inline rejection panel shared by the entity/relation/pattern edit dialogs.
 *
 * Renders the blocking validation findings the save gate returns on a 422
 * (rule id, severity, location, message), or nothing when there are none — so a
 * dialog can stay open after a rejected save and show the user exactly which
 * rule(s) blocked it instead of a generic toast.
 */
export function DialogValidationFindings({ findings }: DialogValidationFindingsProps) {
  const { t } = useTranslation()
  if (!findings || findings.length === 0) return null
  return (
    <div className="shrink-0 space-y-2 border-t border-destructive/50 pt-3">
      <p className="text-sm font-medium text-destructive">
        {t('schemaAgent.editor.findings.validationFailed')}
      </p>
      <div className="space-y-2 max-h-[180px] overflow-y-auto pr-1">
        {findings.map((finding, index) => (
          <FindingRow
            key={`${finding.concept_id}-${finding.location}-${index}`}
            finding={finding}
            concept={undefined}
          />
        ))}
      </div>
    </div>
  )
}
